import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { IPromotionalCode } from '../pages/types';

export type PromotionalCodeQueryOptions = {
  client_id: string;
};

export const getPromotionalCodes = async ({ client_id }: PromotionalCodeQueryOptions): Promise<IPromotionalCode[]> => {
  const consultation = await HttpHandler({
    method: 'GET',
    url: `${environment.CLIENT_URL}/${client_id}/promo-codes`,
  });

  return consultation?.data?.promo_codes;
};
